import { createFileRoute } from '@tanstack/react-router';

import { OfferImporter } from '@/areas/offers/OfferImporter/OfferImporter';
import { canAddOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/offers/csv-importer')({
    staticData: {
        access: { permissions: canAddOffers },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <OfferImporter />;
}
